module.exports = __webpack_public_path__ + "static/img/5.b6c85e46.png";